import ProfilePicture from './ProfilePictureContainer';

export default ProfilePicture;
